export default __webpack_public_path__ + "static/media/monitor-yellow.de84dce3.svg";